import { Text1 } from 'components/shared'
import React from 'react'
import styles from './SortTabs.module.scss'
import { Tab } from './Tab'
import { SortTabEnums, SortTabsProps } from './SortTabs.types'

const tabs = Object.values(SortTabEnums)

const SortTabsComponent = (props: SortTabsProps) => {
  return (
    <div className={styles.container} style={props.style}>
      <Text1 style={ { width: '54px' } }>Sort by</Text1>
      {tabs.map((tab, index) => (
        <Tab
          key={index}
          label={tab}
          isFirst={index === 0}
          isLast={index === tabs.length - 1}
        />
      ))}
    </div>
  )
}

const SortTabs = SortTabsComponent
export { SortTabs }
